module.exports = __webpack_public_path__ + "img/img5.bbebefb3.png";